/* ── BLACKFORGE THEME JS ── */
'use strict';

// ── GALLERY (images + video) ────────────────────────────────────
function initGallery() {
  const thumbs   = document.querySelectorAll('.bf-product__thumb');
  const mainWrap = document.querySelector('.bf-product__main-img');
  const prevBtn  = document.getElementById('bf-nav-prev');
  const nextBtn  = document.getElementById('bf-nav-next');
  if (!thumbs.length || !mainWrap) return;

  let currentIdx = 0;

  function setMainImage(src) {
    const oldVid = mainWrap.querySelector('.bf-main-video');
    if (oldVid) oldVid.remove();
    let img = mainWrap.querySelector('#bf-main-photo');
    if (!img) {
      img = document.createElement('img');
      img.id = 'bf-main-photo';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;max-width:100%';
      mainWrap.insertBefore(img, mainWrap.firstChild);
    }
    img.style.display = 'block';
    img.src = src;
  }

  // Track mute state across video switches
  var videoMuted = true;

  function makeUnmuteBtn(vid) {
    var btn = document.createElement('button');
    btn.className = 'bf-video-unmute';
    btn.setAttribute('aria-label', 'Toggle sound');
    btn.innerHTML = '<span class="bf-unmute-icon bf-unmute-icon--muted">&#128264;</span>';
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      videoMuted = !videoMuted;
      vid.muted = videoMuted;
      btn.querySelector('.bf-unmute-icon').textContent = videoMuted ? '🔇' : '🔊';
      btn.querySelector('.bf-unmute-icon').className = 'bf-unmute-icon' + (videoMuted ? ' bf-unmute-icon--muted' : ' bf-unmute-icon--live');
      if (!videoMuted) vid.play().catch(function(){});
    });
    return btn;
  }

  function setMainVideo(videoSrc) {
    const img = mainWrap.querySelector('#bf-main-photo');
    if (img) img.style.display = 'none';
    const oldVid = mainWrap.querySelector('.bf-main-video');
    if (oldVid) oldVid.remove();
    const wrap = document.createElement('div');
    wrap.className = 'bf-main-video';
    const vid = document.createElement('video');
    vid.autoplay = true; vid.muted = videoMuted; vid.loop = true; vid.playsInline = true;
    vid.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';
    vid.innerHTML = '<source src="' + videoSrc + '" type="video/mp4">';
    wrap.appendChild(vid);
    wrap.appendChild(makeUnmuteBtn(vid));
    mainWrap.insertBefore(wrap, mainWrap.firstChild);
    vid.load(); vid.play().catch(function(){});
  }

  function goTo(idx) {
    if (idx < 0) idx = thumbs.length - 1;
    if (idx >= thumbs.length) idx = 0;
    currentIdx = idx;
    thumbs.forEach(function(t, i) { t.classList.toggle('active', i === idx); });
    var thumb = thumbs[idx];
    var type  = thumb.dataset.mediaType;
    if (type === 'video') {
      setMainVideo(thumb.dataset.videoSources);
    } else {
      var imgEl = thumb.querySelector('img');
      setMainImage(imgEl.src.replace('width=200', 'width=900'));
    }
    // Scroll ONLY the thumbnail strip. scrollIntoView also scrolled the page's clipped layout box
    // sideways on phones, shifting the whole screen over (John 2026-10-18).
    var strip = thumb.parentNode, sr = strip.getBoundingClientRect(), tr = thumb.getBoundingClientRect();
    strip.scrollTo({ left: strip.scrollLeft + (tr.left - sr.left) - (strip.clientWidth - tr.width) / 2, behavior: 'smooth' });
  }

  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { goTo(i); });
  });
  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIdx - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIdx + 1); });

  // Swipe support — lock vertical scroll during horizontal swipe
  var touchStartX = 0;
  var touchStartY = 0;
  var galDragging = false;
  mainWrap.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    galDragging = false;
  }, { passive: true });
  mainWrap.addEventListener('touchmove', function(e) {
    var dx = Math.abs(e.touches[0].clientX - touchStartX);
    var dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (dx > dy && dx > 8) {
      galDragging = true;
      // No preventDefault — allow page to scroll freely
    }
  }, { passive: true });
  mainWrap.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? currentIdx + 1 : currentIdx - 1);
    galDragging = false;
  });
}

// ── VARIANT SELECTOR ───────────────────────────────────────────
function initVariants() {
  const opts = document.querySelectorAll('.bf-variant-opt');
  const priceEl = document.querySelector('.bf-price-block__price');
  const wasEl   = document.querySelector('.bf-price-was');
  const addBtn  = document.querySelector('.bf-add-to-cart');
  const variantInput = document.querySelector('input[name="id"]');

  if (!opts.length) return;

  opts.forEach(opt => {
    opt.addEventListener('click', () => {
      if (opt.classList.contains('unavailable')) return;
      opts.forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');

      const price   = opt.dataset.price;
      const was     = opt.dataset.was;
      const vid     = opt.dataset.variantId;
      const avail   = opt.dataset.available !== 'false';

      if (priceEl && price) priceEl.textContent = '$' + parseInt(price / 100).toLocaleString();
      if (wasEl   && was)   wasEl.textContent   = '$' + parseInt(was   / 100).toLocaleString();
      if (variantInput && vid) variantInput.value = vid;
      if (addBtn) {
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? 'Add to Cart' : 'Unavailable';
      }
    });
  });
}

// ── TABS ────────────────────────────────────────────────────────
function initTabs() {
  const tabBtns    = document.querySelectorAll('.bf-tab-btn');
  const tabPanels  = document.querySelectorAll('.bf-tab-panel');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.hidden = true);
      btn.classList.add('active');
      const panel = document.getElementById('tab-' + btn.dataset.tab);
      if (panel) panel.hidden = false;
    });
  });
}

// ── COLLECTION FILTERS ──────────────────────────────────────────
function initFilters() {
  const filterBtns = document.querySelectorAll('.bf-filter-btn');
  const cards      = document.querySelectorAll('.bf-card[data-tags]');
  const countEl    = document.querySelector('.bf-showing-count');

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      let visible  = 0;
      cards.forEach(card => {
        const tags   = card.dataset.tags || '';
        const show   = filter === 'all' || tags.includes(filter);
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible;
    });
  });
}

// ── CART (AJAX) ─────────────────────────────────────────────────
// ── CART DRAWER ─────────────────────────────────────────────────
var bfPopupTimer = null;

function bfMoney(cents) {
  return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
}



function bfShowAddedPopup(item) {
  var popup   = document.getElementById('bf-added-popup');
  var title   = document.getElementById('bf-popup-title');
  var variant = document.getElementById('bf-popup-variant');
  var img     = document.getElementById('bf-popup-img');
  if (!popup) return;

  if (title)   title.textContent   = item.product_title || item.title || '';
  if (variant && item.variant_title && item.variant_title !== 'Default Title')
               variant.textContent = item.variant_title;
  else if (variant) variant.textContent = '';
  if (img && item.image) img.src = item.image.replace('.jpg', '_120x120.jpg');

  popup.style.pointerEvents = 'auto';
  popup.style.transform = 'translateY(0)';
  popup.style.opacity   = '1';

  clearTimeout(bfPopupTimer);
  bfPopupTimer = setTimeout(bfHidePopup, 6000);
}

function bfHidePopup() {
  var popup = document.getElementById('bf-added-popup');
  if (!popup) return;
  popup.style.transform = 'translateY(120%)';
  popup.style.opacity   = '0';
  popup.style.pointerEvents = 'none';
}


async function bfUpdateCartCount() {
  var res  = await fetch('/cart.js');
  var cart = await res.json();
  document.querySelectorAll('.bf-cart-count').forEach(function(el) {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });
}

function initCart() {
  const forms = document.querySelectorAll('.bf-product-form');

  // Popup buttons
  var continueBtn = document.getElementById('bf-popup-continue');
  var viewCartBtn = document.getElementById('bf-popup-view-cart');
  if (continueBtn) continueBtn.addEventListener('click', bfHidePopup);
  if (viewCartBtn) viewCartBtn.addEventListener('click', function() {
    bfHidePopup();
    window.location.href = '/cart';
  });

  // v95: Checkout goes straight to checkout (rewards popup intercept removed)

  // Add to cart (AJAX — no drawer)
  forms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn  = form.querySelector('.bf-add-to-cart');
      const data = new FormData(form);
      btn.textContent = 'Adding…';
      btn.disabled = true;

      try {
        const res  = await fetch('/cart/add.js', {
          method: 'POST', body: data,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!res.ok) throw new Error('Cart error');
        const item = await res.json();

        await bfUpdateCartCount();
        bfShowAddedPopup(item);

        btn.textContent = '✓ Added!';
        setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 2000);
      } catch (err) {
        btn.textContent = 'Error — Try Again';
        btn.disabled = false;
      }
    });
  });
}

// Mobile menu handled in header.liquid

// ── INTERSECTION OBSERVER (fade in) ────────────────────────────
function initFadeIn() {
  const els = document.querySelectorAll('.bf-fade-in');
  if (!els.length) return;
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.07 });
  els.forEach(el => io.observe(el));
}

// ── INIT ────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  initGallery();
  // Wire unmute button on initial Liquid-rendered video
  var unmuteBtn = document.getElementById('bf-unmute-btn');
  var mainVid   = document.getElementById('bf-main-video');
  if (unmuteBtn && mainVid) {
    unmuteBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      mainVid.muted = !mainVid.muted;
      var icon = unmuteBtn.querySelector('.bf-unmute-icon');
      icon.textContent  = mainVid.muted ? '🔇' : '🔊';
      icon.className = 'bf-unmute-icon' + (mainVid.muted ? ' bf-unmute-icon--muted' : ' bf-unmute-icon--live');
      if (!mainVid.muted) mainVid.play().catch(function(){});
    });
  }
  initVariants();
  initTabs();
  initFilters();
  initCart();
  initFadeIn();
});
